import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-icon';
import './bin-issue-reporter-modal';

class BinIssueReporterButton extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean },
      createIssueAction: { type: Object, attribute: false },
      issuesHref: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      bn-icon {
        margin-right: .25em;
      }
    `];
  }

  render() {
    return html`
      <lit-entity .href="${this.issuesHref}"  @update="${this._onUpdateIssues}"></lit-entity>
      ${renderIf(this.createIssueAction, () => html`
        <button class="button button--outlined"  @click="${this._onClick}" full-width>
          Report a Concern
        </button>

        <bin-issue-reporter-modal
          .href="${this.href}"
          ?hide="${!this.showModal}"
          @close="${() => this.showModal = false}"
        ></bin-issue-reporter-modal>
      `)}
    `;
  }

  _onUpdateIssues(e) {
    const { entity } = e.detail;
    this.createIssueAction = entity && entity.getAction('create-user-reported-issue');
    this.requestUpdate();
  }

  _onClick(e) {
    e.stopPropagation();
    this.showModal = true;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.issuesHref = this.getHref('https://api.binsentry.com/rel/user-reported-issues');
  }
}

window.customElements.define('bin-issue-reporter-button', BinIssueReporterButton);
